import { render, staticRenderFns } from "./ClientDashboardBookingRequestsListItem.vue?vue&type=template&id=3d92dae8"
import script from "./ClientDashboardBookingRequestsListItem.vue?vue&type=script&lang=js"
export * from "./ClientDashboardBookingRequestsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports